import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Store, AppState, AppFields, map, take, filter } from '../store';
import { UserInfo } from '../interfaces';

@Injectable()
export class UserProgramRoleGuard implements CanActivate {

  constructor(
    private store: Store<AppState>,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      return this.store.select(AppFields.App, AppFields.User).pipe(
        take(1),
        filter(u => !!u),
        map((user: UserInfo) => {
        if (user.userProgramRole < 2) {
          return true;
        } else if (state.url.startsWith('/tryoutmembers')) {
          return true;
        } else {
          this.router.navigate(['/tryoutprogram/active']);
          return false;
        }
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/user-program-role.guard.ts